import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';
import { getSurfaceBorder, getThemeTokens } from '../tokens';

export const styledBackstageHeader = (
  theme: Theme,
): BackstageOverrides['BackstageHeader'] => {
  const tokens = getThemeTokens(theme);

  return {
    header: {
      backgroundColor: alpha(theme.palette.background.paper, 0.96),
      backgroundImage: `linear-gradient(135deg, ${alpha(
        theme.palette.primary.light,
        theme.palette.mode === 'dark' ? 0.12 : 0.48,
      )} 0%, ${alpha(theme.palette.background.paper, 0.96)} 58%, ${alpha(
        theme.palette.secondary.light,
        theme.palette.mode === 'dark' ? 0.08 : 0.28,
      )} 100%)`,
      borderBottom: `1px solid ${getSurfaceBorder(theme)}`,
      boxShadow: 'none',
      minHeight: 84,
      overflow: 'hidden',
      padding: theme.spacing(2.75, 6),
      position: 'relative',
      '@media (max-width: 959.95px)': {
        flexWrap: 'unset',
        minHeight: 68,
        padding: theme.spacing(2, 2.25),
      },
      '&::after': {
        background:
          'linear-gradient(90deg, rgba(255, 255, 255, 0.18) 0%, transparent 42%)',
        content: '""',
        inset: 0,
        pointerEvents: 'none',
        position: 'absolute',
      },
      '& *': {
        color: `${tokens.textPrimary} !important`,
      },
    },
    leftItemsBox: {
      gap: theme.spacing(0.75),
      position: 'relative',
      zIndex: 1,
    },
    rightItemsBox: {
      alignItems: 'center',
      gap: theme.spacing(1),
      paddingRight: 0,
      position: 'relative',
      zIndex: 1,
    },
    title: {
      fontSize: theme.typography.h5.fontSize,
      fontWeight: 700,
      lineHeight: 1.1,
      position: 'relative',
      zIndex: 1,
      '@media (max-width: 959.95px)': {
        fontSize: theme.typography.h6.fontSize,
      },
    },
    subtitle: {
      color: alpha(tokens.textSecondary, 0.94),
      fontSize: theme.typography.body2.fontSize,
      marginTop: theme.spacing(0.75),
      maxWidth: 780,
      position: 'relative',
      zIndex: 1,
    },
    type: {
      color: alpha(tokens.textMuted, 0.94),
      fontSize: theme.typography.caption.fontSize,
      fontWeight: 700,
      letterSpacing: '0.08em',
      marginBottom: theme.spacing(0.5),
      position: 'relative',
      textTransform: 'uppercase',
      zIndex: 1,
    },
    breadcrumb: {
      color: alpha(tokens.textSecondary, 0.84),
    },
    breadcrumbType: {
      color: alpha(tokens.textMuted, 0.84),
    },
    breadcrumbTitle: {
      color: tokens.textPrimary,
    },
  };
};
